module.exports = __webpack_public_path__ + "img/si.8ddb168b.svg";